import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=ce0f04d2&"
import script from "./LoginButton.vue?vue&type=script&lang=ts&"
export * from "./LoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./login_button.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports